import getWindow from "../utils/window";
import { BACK_IN_STOCK_NOTIFY_ME_CLICK_TRACKING_NAME } from "./backInStock";

const trackingEvents = {
  pageLoad: new Set(),
  postPageLoad: new Set(),
  addToBag: new Set(),
  addToBagError: new Set(),
  sourcingLocation: new Set(),
  fitAssistantOpen: new Set(),
  fitAssistantClose: new Set(),
  [BACK_IN_STOCK_NOTIFY_ME_CLICK_TRACKING_NAME]: new Set(),
  looksModalOpen: new Set(),
  addToBagLooks: new Set(),
  looksProductView: new Set(),
  looksCtaView: new Set(),
  looksButtonScroll: new Set(),
  looksContentView: new Set(),
  recommendedOutfitsAddToBag: new Set(),
  recommendedOutfitsModalOpen: new Set(),
  recommendedOutfitsCtaView: new Set(),
  waysToStyleCtaView: new Set(),
  waysToStyleModalOpen: new Set(),
  waysToStyleAddToBag: new Set(),
  waysToStyleProductView: new Set(),
  waysToStyleOutfitView: new Set(),
  anonymousBackInStockModal: new Set(),
};

function getEventsForTrackingName(trackingName) {
  return trackingEvents[trackingName];
}

function getEventNameFromEvent(event) {
  return event.split("=")[0];
}

export function setEvents({ events, trackingName }) {
  const currentEvents = getEventsForTrackingName(trackingName);

  for (const event of events) {
    const matchedEvent = [...currentEvents].find((currentEvent) =>
      currentEvent.includes(`${getEventNameFromEvent(event)}=`),
    );
    if (matchedEvent) {
      currentEvents.delete(matchedEvent);
    }
    currentEvents.add(event);
  }
}

export function setLinkTrackEvents({ trackingName }) {
  const s = getWindow().s;
  const currentEvents = [...getEventsForTrackingName(trackingName)];

  s.events = currentEvents.join(",");

  return currentEvents.map((event) => getEventNameFromEvent(event)).join(",");
}

export function clearEvents({ trackingName }) {
  trackingEvents[trackingName].clear();
}
